module.exports = __webpack_public_path__ + "img/add-dos-donts.cc3e7708.svg";